import { render, staticRenderFns } from "./ServerBundles.vue?vue&type=template&id=55968f77"
import script from "./ServerBundles.vue?vue&type=script&lang=js"
export * from "./ServerBundles.vue?vue&type=script&lang=js"
import style0 from "./ServerBundles.vue?vue&type=style&index=0&id=55968f77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports